import {EventDispatcher} from "EventDispatcher";

import {CustomDataEvent} from './CustomDataEvent';


// Simple Event Types
export const EVENT_TYPE_ADD_SPOTS_GRID_COMPLETED = "EVENT_TYPE_ADD_SPOTS_GRID_COMPLETED"

export const EVENT_TYPE_FLYER_PAGE_CONTROLS_SELECT_ALL_SPOTS = "EVENT_TYPE_FLYER_PAGE_CONTROLS_SELECT_ALL_SPOTS"
export const EVENT_TYPE_FLYER_PAGE_CONTROLS_UNSELECT_ALL_SPOTS = "EVENT_TYPE_FLYER_PAGE_CONTROLS_UNSELECT_ALL_SPOTS"
export const EVENT_TYPE_FLYER_PAGE_CONTROLS_DELETE_SPOTS = "EVENT_TYPE_FLYER_PAGE_CONTROLS_DELETE_SPOTS";

export const EVENT_TYPE_SPOTS_UNSELECT_ONE_OR_MORE_SPOTS = "EVENT_TYPE_SPOTS_UNSELECT_ONE_OR_MORE_SPOTS"
export const EVENT_TYPE_SPOTS_ALL_SPOTS_SELECTED_WITH_CTRL_A = "EVENT_TYPE_SPOTS_ALL_SPOTS_SELECTED_WITH_CTRL_A";
export const EVENT_TYPE_SPOTS_NO_SPOTS_SELECTED = "EVENT_TYPE_SPOTS_NO_SPOTS_SELECTED";

export const EVENT_TYPE_READY_FOR_SPOTS_PERSISTENCY_SAVE = "EVENT_TYPE_READY_FOR_SPOTS_PERSISTENCY_SAVE";

export const EVENT_TYPE_PAGE_INDEX_CHANGED = "EVENT_TYPE_PAGE_INDEX_CHANGED";


// Event Types with data
export const EVENT_TYPE_SPOTS_SELECT_ONE_OR_MORE_SPOTS = "EVENT_TYPE_SPOTS_SELECT_ONE_OR_MORE_SPOTS"
export const EVENT_TYPE_FLYER_PAGE_CONTROLS_RENUMBER_FROM = "EVENT_TYPE_FLYER_PAGE_CONTROLS_RENUMBER_FROM";
export const EVENT_TYPE_FLYER_PAGE_CONTROLS_AUTO_NUMBER = "EVENT_TYPE_FLYER_PAGE_CONTROLS_AUTO_NUMBER";
export const EVENT_TYPE_FLYER_SAVE_FRAMES_DATA_AND_AUTO_NUMBER = "EVENT_TYPE_FLYER_SAVE_FRAMES_DATA_AND_AUTO_NUMBER";
export const EVENT_TYPE_FLYER_RIGHT_PANEL_CONTROL_SELECT_NEXT_OR_PREV_FRAME = "EVENT_TYPE_FLYER_RIGHT_PANEL_CONTROL_SELECT_NEXT_OR_PREV_FRAME";
export const EVENT_DATA_TYPE_TITLE_HEADER_DATA_CHANGE = "EVENT_DATA_TYPE_TITLE_HEADER_DATA_CHANGE";
export const EVENT_DATA_TYPE_CREAT_NEW_FLYER = "EVENT_DATA_TYPE_CREAT_NEW_FLYER";
export const EVENT_DATA_TYPE_OPEN_PAGES_FLYER = "EVENT_DATA_TYPE_OPEN_PAGES_FLYER";
export const EVENT_DATA_TYPE_UPLOAD_FILE_TYPE = "EVENT_DATA_TYPE_UPLOAD_FILE_TYPE";
export const EVENT_DATA_TYPE_UPLOAD_FILE_FOR_STORE_TYPE = "EVENT_DATA_TYPE_UPLOAD_FILE_FOR_STORE_TYPE";
export const EVENT_DATA_TYPE_DISABLE_TABS = "EVENT_DATA_TYPE_DISABLE_TABS";
export const EVENT_DATA_TYPE_OPEN_FLYER_INFO_POPUP = "EVENT_DATA_TYPE_OPEN_FLYER_INFO_POPUP";
export const EVENT_TYPE_GET_ALL_SELECTED_SPOTS = "EVENT_TYPE_GET_ALL_SELECTED_SPOTS";
export const EVENT_TYPE_CHANGE_ICON_POSITION = "EVENT_TYPE_CHANGE_ICON_POSITION";


export const EVENT_DATA_TYPE_SPOT_DRAG_TOP_LEFT = "EVENT_DATA_TYPE_SPOT_DRAG_TOP_LEFT";
export const EVENT_DATA_TYPE_SPOT_DRAG_TOP_RIGHT = "EVENT_DATA_TYPE_SPOT_DRAG_TOP_RIGHT";
export const EVENT_DATA_TYPE_SPOT_DRAG_BOTTOM_RIGHT = "EVENT_DATA_TYPE_SPOT_DRAG_BOTTOM_RIGHT";
export const EVENT_DATA_TYPE_SPOT_DRAG_BOTTOM_LEFT = "EVENT_DATA_TYPE_SPOT_DRAG_BOTTOM_LEFT";
export const EVENT_DATA_TYPE_SPOT_PRESS_MOVE = "EVENT_DATA_TYPE_SPOT_PRESS_MOVE";


const eventTypes: string[] = [

    // Event Types
    EVENT_TYPE_ADD_SPOTS_GRID_COMPLETED,

    EVENT_TYPE_FLYER_PAGE_CONTROLS_SELECT_ALL_SPOTS,
    EVENT_TYPE_FLYER_PAGE_CONTROLS_UNSELECT_ALL_SPOTS,
    EVENT_TYPE_FLYER_PAGE_CONTROLS_DELETE_SPOTS,

    EVENT_TYPE_SPOTS_UNSELECT_ONE_OR_MORE_SPOTS,
    EVENT_TYPE_SPOTS_ALL_SPOTS_SELECTED_WITH_CTRL_A,
    EVENT_TYPE_SPOTS_NO_SPOTS_SELECTED,
    EVENT_TYPE_READY_FOR_SPOTS_PERSISTENCY_SAVE,

    EVENT_TYPE_PAGE_INDEX_CHANGED,

    EVENT_DATA_TYPE_SPOT_DRAG_TOP_LEFT,
    EVENT_DATA_TYPE_SPOT_DRAG_TOP_RIGHT,
    EVENT_DATA_TYPE_SPOT_DRAG_BOTTOM_RIGHT,
    EVENT_DATA_TYPE_SPOT_DRAG_BOTTOM_LEFT,
    EVENT_DATA_TYPE_SPOT_PRESS_MOVE,


    // Event Types with data
    EVENT_TYPE_CHANGE_ICON_POSITION,
    EVENT_TYPE_SPOTS_SELECT_ONE_OR_MORE_SPOTS,
    EVENT_TYPE_FLYER_RIGHT_PANEL_CONTROL_SELECT_NEXT_OR_PREV_FRAME,
    EVENT_DATA_TYPE_TITLE_HEADER_DATA_CHANGE,
    EVENT_DATA_TYPE_CREAT_NEW_FLYER,
    EVENT_DATA_TYPE_OPEN_PAGES_FLYER,
    EVENT_DATA_TYPE_DISABLE_TABS,
    EVENT_DATA_TYPE_UPLOAD_FILE_TYPE,
    EVENT_DATA_TYPE_UPLOAD_FILE_FOR_STORE_TYPE,
    EVENT_DATA_TYPE_OPEN_FLYER_INFO_POPUP,
    EVENT_TYPE_GET_ALL_SELECTED_SPOTS,
    EVENT_TYPE_FLYER_SAVE_FRAMES_DATA_AND_AUTO_NUMBER,
    EVENT_TYPE_FLYER_PAGE_CONTROLS_AUTO_NUMBER,
    EVENT_TYPE_FLYER_PAGE_CONTROLS_RENUMBER_FROM,
]
const eventDispatcher: EventDispatcher = new EventDispatcher({validEventTypes: eventTypes});

export function addEventTypeListener(onEventType: string, callback: () => void) {
    eventDispatcher.on(onEventType, callback);
}

export function addEventDataTypeListener(onEventType: string, callback: (event: any) => void) {
    eventDispatcher.on(onEventType, callback);
}

export function removeEventTypeListener(onEventType: string) {
    eventDispatcher.off(onEventType)
}

export function dispatchEventType(eventType: string) {
    eventDispatcher.trigger(eventType)
}

export function dispatchEventDataType<T>(eventType: string, data: any) {
    let event = new CustomDataEvent(eventType);
    event.data = data;

    eventDispatcher.trigger(event)
}